import React from "react";
import NewsCard from "./NewsCard";

const NewsBox = ({newsBox}) => {

    const renderNewsCards = () => {
        return newsBox?.length ? newsBox.map((news, i) => <NewsCard news={news} key = {i+1}/>) : null;
    }

    return (
        <div className="news-box">
            {renderNewsCards()}
        </div>
    )
}

export default NewsBox;